import { render, staticRenderFns } from "./PointTable.vue?vue&type=template&id=39a81437&scoped=true"
import script from "./PointTable.vue?vue&type=script&lang=js"
export * from "./PointTable.vue?vue&type=script&lang=js"
import style0 from "./PointTable.vue?vue&type=style&index=0&id=39a81437&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a81437",
  null
  
)

export default component.exports